import React from 'react'
import { ILink } from '../../models'

function MenuLinkList({ subLinks }: { subLinks: ILink[] }) {
  return (
    <div className="pr-5 md:w-[220px]">
      <ul className="flex flex-col items-start gap-[30px] md:gap-[20px]">
        {subLinks.map((subLink) => (
          <a className="text-sm" href={subLink.Url} key={subLink.Name}>
            <div>
              <span className="text-balance  link-chevron-right-span">
                {subLink.Name}
              </span>
            </div>
          </a>
        ))}
      </ul>
    </div>
  )
}

export default MenuLinkList
